import { cn } from '@/platform/lib/utils';
import { useSidebarNavStore } from '@/platform/stores/useSidebarNavStore';
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    TransitionChild,
} from '@headlessui/react';
import { ChevronLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Navigation from './Navigation';

const SidebarNavigation = () => {
    const { collapsed, toggleCollapse, mobileOpen, setMobileOpen } =
        useSidebarNavStore();

    return (
        <>
            <Dialog
                open={mobileOpen}
                onClose={setMobileOpen}
                className='relative z-50 lg:hidden'
            >
                <DialogBackdrop
                    transition
                    className='fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-linear data-closed:opacity-0'
                />

                <div className='fixed inset-0 flex'>
                    <DialogPanel
                        transition
                        className='relative mr-16 flex w-full max-w-xs flex-1 transform transition duration-300 ease-in-out data-closed:-translate-x-full'
                    >
                        <TransitionChild>
                            <div className='absolute top-0 left-full flex w-16 justify-center pt-5 duration-300 ease-in-out data-closed:opacity-0'>
                                <button
                                    type='button'
                                    onClick={() => setMobileOpen(false)}
                                    className='-m-2.5 p-2.5'
                                >
                                    <span className='sr-only'>
                                        Close sidebar
                                    </span>
                                    <XMarkIcon
                                        aria-hidden='true'
                                        className='size-6 text-white'
                                    />
                                </button>
                            </div>
                        </TransitionChild>

                        <Navigation />
                    </DialogPanel>
                </div>
            </Dialog>

            {/* Static sidebar for desktop */}
            <div
                className={cn(
                    'mt-12 hidden bg-gray-900 transition-all duration-300 ease-in-out lg:fixed lg:inset-y-0 lg:z-20 lg:flex lg:flex-col',
                    collapsed ? 'lg:w-0 lg:overflow-hidden' : 'lg:w-72'
                )}
            >
                <Navigation />
            </div>

            {/* Desktop collapse toggle */}
            <button
                type='button'
                onClick={toggleCollapse}
                aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                className={cn(
                    'fixed top-20 z-20 hidden rounded-r-md border border-l-0 border-gray-200 bg-white px-1.5 py-4 text-gray-500 shadow-xs transition-all duration-300 ease-in-out hover:text-gray-700 lg:block',
                    collapsed ? 'lg:left-0' : 'lg:left-72'
                )}
            >
                <ChevronLeftIcon
                    aria-hidden='true'
                    className={cn(
                        'size-4 transition-transform duration-300',
                        collapsed && 'rotate-180'
                    )}
                />
            </button>
        </>
    );
};

export default SidebarNavigation;
